import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
//import FileProcessing from '../components/FileProcessing.vue'

// Lazy-loaded components
const LoginPage = () => import('@/components/auth/LoginPage.vue')
const ResetPassword = () => import('@/components/auth/ResetPassword.vue')
const DashboardView = () => import('@/components/DashboardView.vue')
const UserProfile = () => import('@/components/UserProfile.vue')
const StockistDetail = () => import('@/components/StockistDetail.vue')
const AdminFilesPage = () => import('@/components/admin/AdminFilesPage.vue')
const FilePreviewPage = () => import('@/components/files/FilePreviewPage.vue')
const MainLayout = () => import('@/layouts/MainLayout.vue')
const Report = () => import('@/components/Reports/Report.vue')
const HQReport = () => import('@/components/Reports/HQReport.vue')
const UserManagement = () => import('@/components/UserManagement.vue')
const FileStatus = () => import('@/components/FileStatus.vue')
const AdminPeriodsPage = () => import('@/components/admin/AdminPeriodsPage.vue')
const TerritoryAsp = () => import('@/components/Reports/TerritoryAsp.vue')
const TerritoryTargets = () => import('@/components/TerritoryTargets.vue')
const StockistAsp = () => import('@/components/Reports/StockistAsp.vue')
const StockistPSC = () => import('@/components/Reports/StockistPSC.vue')
const RepReports = () => import('@/components/Reports/RepReports.vue')
const RepReportsNew = () => import('@/components/RepReportsNew.vue')
const StockistStatusReport = () => import('@/components/StockistStatusReport.vue')
const StockistStatusReportCopy = () => import('@/components/StockistStatusReportCopy.vue')
const ProductTargetAchievement = () => import('@/components/Reports/ProductTargetAchievement.vue')
const SalesPerformanceDashboard = () => import('@/components/SalesPerformanceDashboard.vue')
const PrimaryAllocation = () => import('@/components/PrimaryAllocation.vue')
const SecondaryAllocation = () => import('@/components/SecondaryAllocation.vue')
// V1 approval screens retired 2026-09-22 (V2 is the only approval UI); old paths redirect below.
// const ManageReps = () => import('@/components/ManagerApprovalInterface.vue')
const ManageRepsV2 = () => import('@/components/ManagerApprovalInterfaceV2.vue')
// const SecondaryManagerApproval = () => import('@/components/SecondaryManagerApproval.vue')
const SecondaryManagerApprovalV2 = () => import('@/components/SecondaryManagerApprovalV2.vue')
const StockStats = () => import('@/components/Reports/StockStats.vue')
const HQTerritoryAsp = () => import('@/components/Reports/HQTerritoryAsp.vue')
const UserStats = () => import('@/components/UserStats.vue')
const GeoReplica = () => import('@/components/Reports/GeoReplica.vue')
const TerritoryTargetAchievement = () => import('@/components/Reports/TerritoryTargetAchievement.vue')
const StockistStatusDashboard = () => import('@/components/StockistDashboard/StockistStatusDashboard.vue')
const CompletedStockistStatusDashboard = () => import('@/components/StockistDashboard/CompletedStockistStatusDashboard.vue')
const AdminViewComponent = () => import('@/components/files/AdminViewComponent.vue')
const FLMTransferApproval = () => import('@/components/FLMTransferApproval.vue')
const StockTransferRequest = () => import('@/components/StockTransferRequest.vue')
const SecondaryStockTransferRequest = () => import('@/components/SecondaryStockTransferRequest.vue')
const SecondaryFLMTransferApproval = () => import('@/components/SecondaryFLMTransferApproval.vue')
const S3FileManager = () => import('@/components/S3FileManager.vue')
const JobView = () => import('@/components/JobView.vue')
// const StockistStockStatementReport = () => import('@/components/Reports/StockistStockStatementReport.vue')
const StockistStockStatementReport = () => import('@/components/reports/STOCKIST_STOCK_STATEMENT_REPORT.vue')
const ApprovedTerritoriesReport = () => import('@/components/Reports/Approved_Territories_Report.vue')
const Survey = () => import('@/components/Survey.vue')
const SurveyResponse = () => import('@/components/SurveyResponse.vue')
const AllocationStatusReset = () => import('@/components/admin/AllocationStatusReset.vue')
const AdminAllocationOverride = () => import('@/components/admin/AdminAllocationOverride.vue')
const AdminReports = () => import('@/components/admin/AdminReports.vue')
const AdminTransferManagement = () => import('@/components/admin/AdminTransferManagement.vue')

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/reset-password/:token',  // Add this route
    name: 'reset-password',
    component: ResetPassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        // redirect: '/dashboard',
        name: 'root'
      },
      {
        path: 'rep-reports-new',
        name: 'rep-reports-new',
        component: RepReportsNew,
        meta: { requiresAdmin: true }
      },
      {
        path: 'secondary-uploads',
        name: 'secondary-uploads',
        component: DashboardView,
      },
      {
        path: 'rep-allocation',
        name: 'rep-allocation',
        component: PrimaryAllocation,
      },
      {
        path: 'secondary-allocation',
        name: 'secondary-allocation',
        component: SecondaryAllocation
      },
      // V1 approval routes retired -- keep old bookmarks working by redirecting to V2.
      // {
      //   path: 'manage-reps',
      //   name: 'manage-reps',
      //   component: ManageReps,
      //   meta: { requiresManager: true }
      // },
      // {
      //   path: 'secondary-manager-approval',
      //   name: 'secondary-manager-approval',
      //   component: SecondaryManagerApproval,
      //   meta: { requiresManager: true }
      // },
      { path: 'manage-reps', redirect: '/manage-reps-v2' },
      { path: 'secondary-manager-approval', redirect: '/secondary-manager-approval-v2' },
      {
        path: 'manage-reps-v2',
        name: 'manage-reps-v2',
        component: ManageRepsV2,
        meta: { requiresManager: true }
      },
      {
        path: 'secondary-manager-approval-v2',
        name: 'secondary-manager-approval-v2',
        component: SecondaryManagerApprovalV2,
        meta: { requiresManager: true }
      },
      {
        path: 'reports',
        name: 'reports',
        component: Report,
      },
      {
        path: 'hq_report',
        name: 'hq_report',
        component: HQReport,
      },
      {
        path: 'profile',
        name: 'profile',
        component: UserProfile,
      },
      {
        path: 'stockist/:id',
        name: 'stockist-detail',
        component: StockistDetail,
      },
      {
        path: 'filestatus',
        name: 'file-status',
        component: FileStatus,
      },
      {
        path: 'files/:id',
        name: 'file-preview',
        component: FilePreviewPage,
        props: route => ({ fileId: route.params.id }),
      },
      {
        path: 'admin-view/:id',
        name: 'admin-view',
        component: AdminViewComponent,
        props: route => ({ fileId: route.params.id }),
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'admin/files',
        name: 'admin-files',
        component: AdminFilesPage,
        meta: { requiresAdmin: true }
      },
      {
        path: 'admin/periods',
        name: 'admin-periods',
        component: AdminPeriodsPage,
        meta: { requiresAdmin: true }
      },
      {
        path: 'user-management',
        name: 'user-management',
        component: UserManagement,
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'job-view',
        name: 'job-view',
        component: JobView,
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'territory-asp',
        name: 'territory-asp',
        component: TerritoryAsp,
        meta: { requiresAdmin: true }
      },
      {
        path: 'territory-targets',
        name: 'territory-targets',
        component: TerritoryTargets,
        meta: { requiresAdmin: true }
      },
      {
        path: 'stockist-asp',
        name: 'stockist-asp',
        component: StockistAsp,
        meta: { requiresAdmin: true }
      },
      {
        path: 'stockist-psc',
        name: 'stockist-psc',
        component: StockistPSC,
        meta: { requiresAdmin: true }
      },
      {
        path: 'stockist-status-dashboard',
        name: 'stockist-status-dashboard',
        component: StockistStatusDashboard,
        meta: { requiresAdmin: true }
      },
      {
        path: 'modified-stockist-status-dashboard',
        name: 'modified-stockist-status-dashboard',
        component: CompletedStockistStatusDashboard,
        meta: { requiresAdmin: true }
      },
      {
        path: 'rep-reports',
        name: 'rep-reports',
        component: RepReports,
        meta: { requiresAdmin: true }
      },
      {
        path: 'stockist-status-report',
        name: 'stockist-status-report',
        component: StockistStatusReport,
        meta: { requiresAdmin: true }
      },
      {
        path: 'stockist-status-report-hierarchy',
        name: 'stockist-status-report-hierarchy',
        component: StockistStatusReportCopy,
        meta: { requiresAdmin: true }
      },
      {
        path: 'product-target-achievement',
        name: 'product-target-achievement',
        component: ProductTargetAchievement,
        meta: { requiresAdmin: true }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: SalesPerformanceDashboard,
        meta: { requiresAdmin: true }
      },
      {
        path: 'stock-stats',
        name: 'stock-stats',
        component: StockStats,
        meta: { requiresAdmin: true }
      },
      {
        path: 'hq-territory-asp',
        name: 'hq-territory-asp',
        component: HQTerritoryAsp,
        meta: { requiresAdmin: true }
      },
      {
        path: 'user-stats',
        name: 'user-stats',
        component: UserStats,
        meta: { requiresAdmin: true }
      },
      {
        path: 'territory-target-achievement',
        name: 'territory-target-achievement',
        component: TerritoryTargetAchievement,
        meta: { requiresAdmin: true }
      },
      {
        path: 'geo-replica',
        name: 'geo-replica',
        component: GeoReplica,
        meta: { requiresAdmin: true }
      },

      {
        'path': 'flm-transfer-approval',
        'name': 'flm-transfer-approval',
        'component': FLMTransferApproval,
      }, {
        'path': 'secondary-flm-transfer-approval',
        'name': 'secondary-flm-transfer-approval',
        'component': SecondaryFLMTransferApproval,
      }, {
        'path': 'stock-transfer-request',
        'name': 'stock-transfer-request',
        'component': StockTransferRequest,
      }, {
        'path': 'secondary-stock-transfer-request',
        'name': 'secondary-stock-transfer-request',
        'component': SecondaryStockTransferRequest,
      },
      {
        path: 's3-file-manager',
        name: 's3-file-manager',
        component: S3FileManager,
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'stockist-stock-statement-report',
        name: 'stockist-stock-statement-report',
        component: StockistStockStatementReport,
        meta: { requiresAdmin: true }
      },
      {
        path: 'approved-territories-report',
        name: 'approved-territories-report',
        component: ApprovedTerritoriesReport,
        meta: { requiresAdmin: true }
      },
      {
        path: 'survey',
        name: 'survey',
        component: Survey
      },
      {
        path: 'survey-response',
        name: 'survey-response',
        component: SurveyResponse
      },
      {
        path: 'admin/allocation-status-reset',
        name: 'allocation-status-reset',
        component: AllocationStatusReset,
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'admin/allocation-override',
        name: 'admin-allocation-override',
        component: AdminAllocationOverride,
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'admin/reports',
        name: 'admin-reports',
        component: AdminReports,
        meta: { requiresSuperAdmin: true }
      },
      {
        path: 'admin/transfer-management',
        name: 'admin-transfer-management',
        component: AdminTransferManagement,
        meta: { requiresSuperAdmin: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard
router.beforeEach(async (to, from, next) => {
  const { checkAuth, isAuthenticated, user } = useAuth();

  // Skip auth check for login and reset-password pages
  if (to.name === 'login' || to.name === 'reset-password') {
    if (to.name === 'login' && isAuthenticated.value) {
      const intendedRoute = localStorage.getItem('intendedRoute');
      localStorage.removeItem('intendedRoute');
      next(intendedRoute || { name: 'rep-reports' });
    } else {
      next();
    }
    return;
  }

  // For all other routes, check authentication
  try {
    const isValid = await checkAuth();  // ← User data loads HERE

    if (!isValid) {
      localStorage.setItem('intendedRoute', to.fullPath);
      next({ name: 'login' });
      return;
    }

    // ✅ NOW handle root redirect - user data is available
    if (to.path === '/' || to.name === 'root') {
      if (user.value?.level === 'TERRITORY' ||
        user.value?.level === 'FLM' ||
        user.value?.role === 'super_admin') {
        next('/dashboard');
      } else {
        next('/dashboard');
      }
      return;  // ← Important: return after next()
    }

    // Rest of your existing auth checks
    const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
    const requiresSuperAdmin = to.matched.some(record => record.meta.requiresSuperAdmin);
    const requiresManager = to.matched.some(record => record.meta.requiresManager);

    if (!isAuthenticated.value) {
      localStorage.setItem('intendedRoute', to.fullPath);
      next({ name: 'login' });
    } else if (requiresAdmin && !['admin', 'super_admin'].includes(user.value?.role)) {
      next({ name: 'rep-reports', query: { error: 'not_admin' } });
    } else if (requiresSuperAdmin && user.value?.role !== 'super_admin') {
      next({ name: 'rep-reports', query: { error: 'not_super_admin' } });
    } else if (requiresManager && !['manager', 'admin', 'super_admin'].includes(user.value?.role)) {
      next({ name: 'rep-reports', query: { error: 'not_manager' } });
    } else {
      next();
    }
  } catch (error) {
    console.error('Auth check failed:', error);
    localStorage.setItem('intendedRoute', to.fullPath);
    next({ name: 'login' });
  }
});



export default router
